import ImgixImg from '@uswitch/ev-components/lib/components/elements/imgix-img/index'
import { useCategoryGuides } from '@uswitch/ev-components/lib/components/modules/category-guides-module/use-category-guides'
import { useEntity } from '@uswitch/ev-utils/context/selectors'
import React from 'react'
import { Themed } from 'theme-ui'

import * as styles from './styles'

const CategoryGuidesModule = (props) => {
  const filteredGuides = useCategoryGuides({ guides: props.guides })

  const connectedEntity = filteredGuides?.[0]?.fields?.variants?.length
    ? filteredGuides?.[0]?.fields?.variants[0]
    : filteredGuides?.[0]?.fields?.entry || filteredGuides?.[0]?.fields?.link

  const pageEntity = useEntity(connectedEntity)

  const d = new Date(pageEntity.sys.updatedAt)
  const pageDate = d.toLocaleString('default', { day: 'numeric', month: 'long', year: 'numeric' })

  const imgSizes = '768px'

  const pageDetails = {
    ...pageEntity,
    description: pageEntity.metaDescription,
    image: pageEntity.metaImage,
    date: pageDate,
    linkHref: filteredGuides?.[0]?.fields?.canonical
  }

  const authorDetails = useEntity(props?.guides[0]?.fields?.authors[0])
  const authorImageEntity = useEntity(authorDetails.image)

  const { className = '', critical = false, trackInteraction = () => {}, pageType } = props

  const { linkHref, description, title } = pageDetails

  const imageEntity = useEntity(pageDetails.image)

  return (
    <div className={className} sx={styles.wrapper}>
      <div sx={styles.imageWrapper}>
        <ImgixImg
          alt={description}
          src={imageEntity?.file?.url}
          sizes={imgSizes}
          sx={styles.image}
          critical={critical}
        />
      </div>

      <div sx={{ ...styles.imageWrapper }}>
        <div
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1',
            ...styles.content,
            mr: 0,
            ml: 'auto',
            padding: ['md', 'lg']
          }}
        >
          {pageType && (
            <div>
              <span sx={{ fontSize: '14px', textTransform: 'uppercase', mb: 'sm', display: 'block' }}>{pageType}</span>
            </div>
          )}

          {title && (
            <Themed.h3 sx={{ margin: '0', textDecoration: 'underline', ...styles.h3 }}>
              <Themed.a href={linkHref} onClick={trackInteraction}>
                {title}
              </Themed.a>
            </Themed.h3>
          )}

          {description && <Themed.p sx={{ ...styles.description }}>{description}</Themed.p>}

          {authorDetails && (
            <div sx={styles.authorWrapper}>
              <div sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 'xxs' }}>
                <ImgixImg
                  alt={authorDetails.name}
                  src={authorImageEntity?.file?.url}
                  width='32px'
                  height='32px'
                  sx={styles.authorImage}
                  critical={critical}
                />
              </div>

              <div>
                <span sx={styles.authorName}>
                  <Themed.a href={authorDetails.url} onClick={trackInteraction}>
                    {`${authorDetails.name}, ${authorDetails.role}`}
                  </Themed.a>
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CategoryGuidesModule
